import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import StorageIcon from '@material-ui/icons/Storage';

export const repositoriesPlugin = createFrontendPlugin({
  pluginId: 'repositories',
  title: 'Repositories',
  icon: <StorageIcon />,
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/repositories',
        title: 'Repositories',
        icon: <StorageIcon />,
        loader: async () =>
          import('./RepositoriesPage').then(module => (
            <module.RepositoriesPage />
          )),
      },
    }),
  ],
});
